import moment from 'moment';
import FraudAndDisputeStore from '../stores/FraudAndDisputeStore';
import general from '../config/General';
import {
  CLAIM_TYPE,
  GOODS,
  SERVICES,
  TRAVEL,
} from '../constants/FraudAndDisputeConstants';

export const getDisputeApiPayload = (userDetails, transactionDetails) => {
  const contactInfo = userDetails?.phone_numbers?.filter(
    (number) => number.preferred
  );
  const emailAddress = userDetails?.email_addresses?.filter(
    (id) => id.preferred
  );
  return {
    claims: [
      {
        account: {
          sort_code: transactionDetails?.sortCode,
          account_number: transactionDetails?.account,
        },
        customer: {
          customer_id: userDetails?.id,
          name: userDetails?.firstName,
          email: emailAddress[0]?.value,
          mobile: contactInfo[0]?.phone_number,
        },
        transaction: [
          {
            transaction_id: transactionDetails?.id,
            transaction_name: transactionDetails?.merchantName,
            transaction_date_time: transactionDetails?.dateRaw,
            amount: Math.abs(transactionDetails?.rawAmount),
          },
        ],
        dispute: {
          dispute_type: FraudAndDisputeStore.getDisputeJourneyType(),
          ...(FraudAndDisputeStore.getDisputeJourneyType() === GOODS && {
            goods: {
              goods_description: FraudAndDisputeStore.getGoodsDescriptionText(),
              due_date: moment(
                FraudAndDisputeStore.getGoodsExptectedDeliveryDate()
              ).format(general.dateFormat),
            },
          }),
          ...(FraudAndDisputeStore.getDisputeJourneyType() === TRAVEL && {
            travel: {
              departure_date: moment(
                FraudAndDisputeStore.getExpectedTravelDepartureDate()
              ).format(general.dateFormat),
              return_date: moment(
                FraudAndDisputeStore.getExpectedTravelReturnDate()
              ).format(general.dateFormat),
              travel_description:
                FraudAndDisputeStore.getTravelDescriptionText(),
            },
          }),
          ...(FraudAndDisputeStore.getDisputeJourneyType() === SERVICES && {
            service: {
              service_description:
                FraudAndDisputeStore.getServiceDescriptionText(),
              service_start_date: moment(
                FraudAndDisputeStore.getExptectedServiceStartDate()
              ).format(general.dateFormat),
            },
          }),
        },

        retailer_contact: {
          contact_date: moment(
            FraudAndDisputeStore.getSellerContactDate()
          ).format(general.dateFormat),
          contact_notes: FraudAndDisputeStore.getSellerContactDescriptionText(),
        },
        claim_amount:
          FraudAndDisputeStore.getRefundType() === CLAIM_TYPE.PARTIAL_REFUND
            ? CLAIM_TYPE.PARTIAL_REFUND
            : CLAIM_TYPE.FULL_REFUND,
        ...(FraudAndDisputeStore.getRefundType() ===
          CLAIM_TYPE.PARTIAL_REFUND && {
          partial_amount: Math.abs(
            parseFloat(FraudAndDisputeStore.getPartialRefundAmount())
          ),
        }),
      },
    ],
  };
};
